import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

import { t } from '../../services/translate';

/** Branded engine-piston loader — pure-CSS, inherits currentColor, honours reduced-motion. */
@Component({
  selector: 'wpp-piston-loader',
  imports: [],
  templateUrl: './piston-loader.component.html',
  styleUrl: './piston-loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'data-wpp-planner': '',
    '[class.pl--centered]': 'centered()',
    '[style.--pl-size]': 'size()',
    '[style.--pl-duration]': 'duration()',
    '[attr.role]': "accessibleName() ? 'img' : null",
    '[attr.aria-label]': 'accessibleName() || null',
    '[attr.aria-hidden]': "accessibleName() ? null : 'true'",
  },
})
export class PistonLoaderComponent {
  /** Height of the piston (any CSS length); width follows the 1:2 ratio. */
  public readonly size = input<string>('96px');
  /** Duration of one full crank rotation (any CSS time). */
  public readonly duration = input<string>('2.4s');
  /** Visible caption shown beneath the piston; also used as the accessible name. */
  public readonly text = input<string>('');
  /** Accessible name when no visible text is set; pass '' to render as decorative. */
  public readonly label = input<string>(t('wpp.component.piston-loader.label'));
  /** Center vertically in the viewport when used as a standalone page loader. */
  public readonly centered = input(false, { transform: booleanAttribute });

  protected readonly accessibleName = computed((): string => this.text() || this.label());
}
